import { call, put, takeLatest } from "redux-saga/effects";
import { FETCH_USER_ROLES_REQUEST } from "../actions/actionTypes.js";
import { fetchUserRolesFailure, fetchUserRolesSuccess } from "../actions/userRoles.actions.js";
import { httpGet } from "../../Utils/apis/apis.js";

function* fetchUserRolesSaga() {
  try {
    const apiUrl = "/common/userrole";
    const response = yield call(httpGet, apiUrl);

    const data = response?.message ? {} : response ?? {};

    yield put(fetchUserRolesSuccess(data));
  } catch (error) {
    yield put(fetchUserRolesFailure(error.message || "Something went wrong"));
  }
}

export default function* userRolesWatcherSaga() {
  yield takeLatest(FETCH_USER_ROLES_REQUEST, fetchUserRolesSaga);
}
